import { LayoutGrid, List, Table2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export type ViewMode = 'table' | 'cards' | 'list';

interface DataViewToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
  availableModes?: ViewMode[];
  className?: string;
}

const viewModeConfig: Record<ViewMode, { icon: React.ComponentType<{ className?: string }>; label: string }> = {
  table: { icon: Table2, label: 'Table view' },
  cards: { icon: LayoutGrid, label: 'Card view' },
  list: { icon: List, label: 'List view' },
};

export const DataViewToggle = ({
  value,
  onChange,
  availableModes = ['table', 'cards'],
  className,
}: DataViewToggleProps) => {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-lg',
        'bg-secondary-100 dark:bg-secondary-800',
        'p-1',
        className
      )}
    >
      {availableModes.map((mode) => {
        const { icon: Icon, label } = viewModeConfig[mode];
        const isActive = value === mode;

        return (
          <button
            key={mode}
            onClick={() => onChange(mode)}
            title={label}
            className={cn(
              'flex items-center justify-center',
              'w-8 h-8 rounded-md',
              'transition-all duration-150',
              isActive
                ? 'bg-white dark:bg-secondary-700 text-primary-600 dark:text-primary-400 shadow-sm'
                : 'text-secondary-500 dark:text-secondary-400 hover:text-secondary-700 dark:hover:text-secondary-300'
            )}
          >
            <Icon className="h-4 w-4" />
          </button>
        );
      })}
    </div>
  );
};

export default DataViewToggle;
